import React, { useState } from "react";
import { useAuthState } from "src/shared/contexts/AuthContext";
import { User } from "types/User";
import useTranslation from "next-translate/useTranslation";
import Head from "next/head";
import SmileSignupPageLayout from "./components/Layouts/SmileSignupPageLayout";
import SmileSignupCreateForm from "./components/Forms/SmileSignupCreateForm";
import SmileSignupInfosForm from "./components/Forms/SmileSignupInfosForm";
import SmileSignupSubscriptionForm from "./components/Forms/SmileSignupSubscriptionForm";

const SIGNUP_FORMS = [SmileSignupCreateForm, SmileSignupInfosForm, SmileSignupSubscriptionForm];

const getStepTitle = (stageQuery: SmileSignUpSteps) => {
  switch (stageQuery) {
    case SmileSignUpSteps.CREATE_STEP:
      return "stepOne";
    case SmileSignUpSteps.INFOS_STEP:
      return "stepTwo";
    case SmileSignUpSteps.PLANS_STEP:
      return "stepThreeTitle";
    default:
      return "stepOne";
  }
};

export enum SmileSignUpSteps {
  CREATE_STEP,
  INFOS_STEP,
  PLANS_STEP,
}

const getInitialStep = (profile?: User) => {
  if (!profile) return SmileSignUpSteps.CREATE_STEP;

  if (!profile?.infos?.lastName && !profile?.infos?.phone) {
    return SmileSignUpSteps.INFOS_STEP;
  }

  return SmileSignUpSteps.PLANS_STEP;
};

const SmileSignUp = () => {
  const { profile } = useAuthState();
  const [step, setStep] = useState(getInitialStep(profile));
  const { t } = useTranslation();
  const SignUpFormComponent = SIGNUP_FORMS[step];
  return (
    <>
      <Head>
        <title>{t("smile:smileSignup_pageTitle")}</title>
      </Head>
      <SmileSignupPageLayout step={step} setStep={setStep} stepTitle={t(`smile:smileSignup_${getStepTitle(step)}`)}>
        <SignUpFormComponent setStep={setStep} />
      </SmileSignupPageLayout>
    </>
  );
};

export default SmileSignUp;
